// Interest calculation utility for Money Market deals
// Formula: (Principal * Interest Rate / 100) / 365 * Tenor

export function calculateInterestAmount(principal, interestRate, tenor) {
  if (!principal || !interestRate || !tenor) return 0;
  const amount = (Number(principal) * Number(interestRate) / 100) / 365 * Number(tenor);
  // Truncate to 4 decimal places (not rounded)
  return Math.floor(amount * 10000) / 10000;
}
